export { default } from "@casino/client/components/Translation";
